// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/ab2af474118e949e8c5c.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"7f43c15541710d58c4be","119":"ed125411477fb0278c41","120":"af067163700be8e3d696"}[chunkId] + ".chunk.js";
};